export enum IconType {
    barcode = 'barcode',
    carrier = 'carrier',
    circleX = 'circleX',
    clone = 'clone',
    close = 'close',
    collapse = 'collapse',
    collapseAll = 'collapseAll',
    collapseTree = 'collapseTree',
    contact = 'contact',
    copy = 'copy',
    drag = 'drag',
    edit = 'edit',
    email = 'email',
    error = 'error',
    expand = 'expand',
    expandAll = 'expandAll',
    expandTree = 'expandTree',
    export = 'export',
    firebend = 'firebend',
    filter = 'filter',
    hide = 'hide',
    home = 'home',
    info = 'info',
    inlineMenu = 'inlineMenu',
    item = 'item',
    list = 'list',
    load = 'load',
    location = 'location',
    manage = 'manage',
    menu = 'menu',
    moneyCheck = 'moneyCheck',
    notification = 'notification',
    phone = 'phone',
    play = 'play',
    plus = 'plus',
    question = 'question',
    refresh = 'refresh',
    reporting = 'reporting',
    route = 'route',
    search = 'search',
    success = 'success',
    transportation = 'transportation',
    undo = 'undo',
    upload = 'upload',
    user = 'user',
    view = 'view',
    viewDetails = 'viewDetails',
    warning = 'warning',
    receiving = 'receiving',
    putAway = 'putAway',
    picking = 'picking',
    packing = 'packing',
    replenishments = 'replenishments',
    cycleCounts = 'cycleCounts',
    exceptions = 'exceptions',
    management = 'management',
    platformCore = 'platformCore',
    platformWms = 'platformWms',
    ltl = 'ltl',
    addHandlingUnit = 'addHandlingUnit',
    parts = 'parts',
    uniform = 'uniform',
    print = 'print',
    download = 'download',
    truckCheck = 'truckCheck',
    scrollToTop = 'scrollToTop',
    helpChat = 'helpChat',
    documentation = 'documentation',
    trash = 'trash',
}

export interface IconProps {
    iconType: string;
    style?: string;
    classes?: string[];
}
